class CopyService extends BaseService
	@registerService()
	@inject '$filter'

	copy: (object, fileKey = null, destination = {}) ->
		if _.isArray(object)
			if _.isEmpty(destination) || !_.isArray(destination)
				destination = []

			return angular.copy(object, destination)

		if !fileKey? || !object[fileKey]?
			return angular.copy(object, destination)

		file = object[fileKey]
		angular.copy(object, destination)
		destination[fileKey] = file

		return destination

	copyEntity: (originalEntity, extraFields = {}) ->
		entity = @copy(originalEntity)

		entity = @removeId(entity, 'root', extraFields)

		if entity.name?
			entity.name += " (#{@$filter('translate')('general.a.copy')})"

		return entity

	removeId: (data, type, extraFields) ->
		if _.isArray(data)
			data = data.map (datum) => @removeId(datum, type, extraFields)

			return data

		if _.isObject data
			fieldsToRemove = ['id', 'parent_id', 'update_time', 'create_time']

			if extraFields[type]?
				fieldsToRemove.push extraFields[type]...

			for field in fieldsToRemove
				if data.hasOwnProperty(field)
					data[field] = null

			for own key, value of data
				subType = if type != 'root' then type + '.' + key else key

				value = @removeId(value, subType, extraFields)

		return data
